module.exports = "/_next/static/images/HeroMobile@2x-442761fa68e4d64944ae120f6d672ff0.png";